import {IServiceFactory} from "../service-factory.interface";
import {IEnvironmentLocalStorageService} from "../storage/environment-local-storage/environment-local-storage.service.interface";
import {EnvSessionStorageKeys} from "../storage/environment-session-storage/environment-session-storage-keys";
import {EnvLocalStorageKeys} from "../storage/environment-local-storage/environment-local-storage-keys";
import {IEnvironmentSessionStorageService} from "../storage/environment-session-storage/environment-session-storage.service.interface";


export class UserRefreshTokenStorage {
    constructor(public readonly hasRememberMe: boolean,
                refreshToken : string,
                private readonly services: IServiceFactory) {
        if(hasRememberMe) {
            this._storageWriter = new LocalStorageRefreshTokenWriter(services.envLocalStorage);
        } else {
            this._storageWriter = new SessionStorageRefreshTokenWriter(services.envSessionStorage);
        }
        this.setRefreshToken(refreshToken);
    }

    private readonly _storageWriter: IRefreshTokenStorageWriter;

    static fromStorage(services: IServiceFactory): UserRefreshTokenStorage | null {
        let refreshToken = services.envLocalStorage.getItem(EnvLocalStorageKeys.UserRefreshToken);
        if(refreshToken) {
            return new UserRefreshTokenStorage(true, refreshToken, services);
        }

        refreshToken = services.envSessionStorage.getItem(EnvSessionStorageKeys.UserRefreshToken);
        if(refreshToken) {
            return new UserRefreshTokenStorage(false, refreshToken, services);
        }

        return null;
    }

    get hasRefreshToken(): boolean {
        return Boolean(this.getRefreshToken());
    }

    getRefreshToken(): string {
        return this._storageWriter.getRefreshToken();
    }

    setRefreshToken(refreshToken: string) {
        this._storageWriter.setRefreshToken(refreshToken);
    }

    removeRefreshToken() {
        this.services.envSessionStorage.removeItem(EnvSessionStorageKeys.UserRefreshToken);
        this.services.envLocalStorage.removeItem(EnvLocalStorageKeys.UserRefreshToken);
    }
}

interface IRefreshTokenStorageWriter {
    setRefreshToken(refreshToken: string): void;
    getRefreshToken(): string;
}

class LocalStorageRefreshTokenWriter implements IRefreshTokenStorageWriter{
    constructor(private readonly localStorageService: IEnvironmentLocalStorageService) {
    }

    setRefreshToken(refreshToken: string): void {
        this.localStorageService.setItem(EnvLocalStorageKeys.UserRefreshToken, refreshToken);
    }
    getRefreshToken(): string {
        return this.localStorageService.getItem(EnvLocalStorageKeys.UserRefreshToken) ?? "";
    }
}

class SessionStorageRefreshTokenWriter implements IRefreshTokenStorageWriter{
    constructor(private readonly sessionStorageService: IEnvironmentSessionStorageService) {
    }

    setRefreshToken(refreshToken: string): void {
        this.sessionStorageService.setItem(EnvSessionStorageKeys.UserRefreshToken, refreshToken);
    }
    getRefreshToken(): string {
        return this.sessionStorageService.getItem(EnvSessionStorageKeys.UserRefreshToken) ?? "";
    }
}